import * as React from 'react';
import { LocalForm, Control } from 'react-redux-form';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { renderNewTextField, renderCheckbox } from '../../common/forms/FieldCreators';
import { localizations } from '../../localization/localization';
import { UserWithSettingsModel, ContactWithSettings } from '../models/SettingsModels';
import FormItem from '../../components/forms/FormItem';
import { nameofMany } from '../../utils/nameof';

interface DialogProps {
    open: boolean;
}

interface EditActions {
    onSubmit: (user: UserWithSettingsModel) => void;
    onCancel: () => void;
}

interface EditUserProps {
    model?: UserWithSettingsModel;
}

type EditUserFormProps = EditUserProps & EditActions & DialogProps;

const EditUserForm = (props: EditUserFormProps) => {
    return (
        <Dialog open={props.open}>
            <LocalForm onSubmit={(values) => props.onSubmit(values)} initialState={props.model}>
                <DialogTitle style={{ textAlign: "center" }}>
                    <Typography variant="h4" paragraph>{localizations.settings.editUser}</Typography>
                </DialogTitle>
                <DialogContent>
                    <FormItem>
                        <Control.text model=".firstName" component={renderNewTextField} label={localizations.common.firstName} />
                    </FormItem>
                    <FormItem>
                        <Control.text model=".lastName" component={renderNewTextField} label={localizations.common.lastName} />
                    </FormItem>
                    <FormItem>
                        <Control.text model=".contact.email" disabled component={renderNewTextField} label={localizations.common.email} />
                    </FormItem>
                    <FormItem>
                        <Control.text model=".contact.emailDetails" component={renderNewTextField} label={localizations.common.emailDetails} />
                    </FormItem>
                    <FormItem>
                        <FormControlLabel
                            control={
                                <Control.checkbox
                                    model={`.${nameofMany<UserWithSettingsModel, ContactWithSettings>("contact", "emailVisible")}`}
                                    component={renderCheckbox}
                                />
                            }
                            label={localizations.settings.emailVisible}
                        />
                    </FormItem>
                    <FormItem>
                        <Control.text model=".contact.phoneNumber" component={renderNewTextField} label={localizations.common.phoneNumber} />
                    </FormItem>
                    <FormItem>
                        <Control.text model=".contact.phoneDetails" component={renderNewTextField} label={localizations.common.phoneNumberDetails} />
                    </FormItem>
                    <FormItem>
                        <FormControlLabel
                            control={
                                <Control.checkbox
                                    model={`.${nameofMany<UserWithSettingsModel, ContactWithSettings>("contact", "phoneNumberVisible")}`}
                                    component={renderCheckbox}
                                />
                            }
                            label={localizations.settings.phoneNumberVisible}
                        />                        
                    </FormItem>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onCancel}>{localizations.actions.cancel}</Button>
                    <Button type="submit">{localizations.actions.ok}</Button>
                </DialogActions>
            </LocalForm>
        </Dialog>
    );
}

export default EditUserForm;


// WEBPACK FOOTER //
// ./src/account/forms/EditUserForm.tsx